module.exports = __webpack_public_path__ + "media/images/step-one-d5ab662e.svg";